/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import axios from "axios";
import { devLog } from "@/utils/devLog";

/**
 * Poll les métadonnées now-playing toutes les `intervalMs` ms.
 * Renvoie un map { [radio_id]: { artist, title, artwork, ... } }.
 */
export function useMetadataPolling(apiBase, intervalMs) {
  const [metaMap, setMetaMap] = useState({});

  useEffect(() => {
    let timer;
    let cancelled = false;

    const tick = async () => {
      try {
        const r = await axios.get(`${apiBase}/now-playing-all`);
        if (cancelled) return;
        const map = {};
        (r.data.items || []).forEach((it) => {
          map[it.radio_id] = it;
        });
        setMetaMap(map);
      } catch (e) {
        if (!cancelled) devLog("now-playing-all failed", e);
      }
    };

    tick();
    timer = setInterval(tick, intervalMs);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [apiBase, intervalMs]);

  return metaMap;
}
